"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPRequest = void 0;
var request_headers_1 = require("./request_headers");
var HTTPRequest = /** @class */ (function () {
    function HTTPRequest(url, params) {
        this.url = url;
        this.method = (params === null || params === void 0 ? void 0 : params.method) || 'GET';
        this.headers = new request_headers_1.HTTPRequestHeaders(params === null || params === void 0 ? void 0 : params.headers);
        this.options = (params === null || params === void 0 ? void 0 : params.options) || {};
        this.payload = params === null || params === void 0 ? void 0 : params.payload;
        this.urlExpanded = (params === null || params === void 0 ? void 0 : params.urlExpanded) || false;
        this.retryOptions = (params === null || params === void 0 ? void 0 : params.retryOptions) || {};
    }
    HTTPRequest.create = function (url, params) {
        return new HTTPRequest(url, params);
    };
    HTTPRequest.prototype.clone = function () {
        var copy = new HTTPRequest(this.url);
        copy.method = this.method;
        copy.headers = new request_headers_1.HTTPRequestHeaders(this.headers.toJSON());
        copy.options = this.options;
        copy.payload = this.payload;
        copy.urlExpanded = this.urlExpanded;
        copy.retryOptions = this.retryOptions;
        return copy;
    };
    return HTTPRequest;
}());
exports.HTTPRequest = HTTPRequest;
//# sourceMappingURL=request.js.map